import { LoaderSpinnerComponent } from '@aston/foundation/components';
import { UnsubscriberClass } from '@aston/foundation';
import { Component, OnInit, inject } from '@angular/core';

import { AuthenticationService } from '../../services';

@Component({
	selector: 'register-page',
	templateUrl: './register-page.component.html',
	imports: [LoaderSpinnerComponent]
})
export class RegisterPageComponent extends UnsubscriberClass implements OnInit {
	private authenticationService = inject(AuthenticationService);


	ngOnInit() {
		this.authenticationService.revokeTokens();

		// The login method will redirect the user to Aston Gate Login page
		// The server will check for creatingAccount=true param presence and redirect the user to account creation page and keep the auth params
		// When the account will be created, Aston Gate will connect the user
		// Then, thank to the initial params, the server will lead the user to the Console login callback page
		const customParams = {
			creatingAccount: true,
			origin: document.location.origin
		};

		// Include the accountEmail if provided
		const queryParams = this.queryParams();
		if (queryParams.accountEmail) customParams['accountEmail'] = queryParams.accountEmail;

		this.authenticationService.login({ customParams });
	}

	queryParams(): Record<string, string> {
		return decodeURIComponent(location.search.slice(1)).split('&').reduce((acc, q) => {
			const param = q.split('=');
			return {...acc, [param[0]]: param[1]}
		}, {});
	}
}
